import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';

var PageLayout = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PageLayout, _React$PureComponent);

  function PageLayout() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = PageLayout.prototype;

  _proto.renderContent = function renderContent() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: "page-layout-content"
    }, children);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        hero = _this$props.hero,
        subfooter = _this$props.subfooter;
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, hero, this.renderContent(), subfooter);
  };

  return PageLayout;
}(React.PureComponent);

export { PageLayout as default };
PageLayout.defaultProps = {
  className: '',
  hero: null,
  subfooter: null
};